import React, { useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDownIcon } from "lucide-react";
import { navItems } from "../data/navigation";
const ease = [0.23, 1, 0.32, 1] as const;
export function MobileMenu() {
  const [expanded, setExpanded] = useState<string | null>(null);
  return <motion.nav aria-label="Navigation mobile" initial={{
    opacity: 0,
    y: -8
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: -8
  }} transition={{
    duration: 0.22,
    ease
  }} className="max-h-[calc(100svh-5rem)] overflow-y-auto border-t border-line bg-paper px-5 pb-8 pt-4 xl:hidden" data-id="element-143" data-mp="2assbgdgdeq28">
      <ul className="divide-y divide-line" data-id="element-144" data-mp="2tm5zrzpkvy8v">
        {navItems.map(item => item.children ? <li key={item.label} data-id="element-145" data-mp="2ylilgh4pqz9v">
              <button type="button" aria-expanded={expanded === item.label} onClick={() => setExpanded(expanded === item.label ? null : item.label)} className="flex w-full items-center justify-between py-4 text-left font-display text-xl text-ink" data-id="element-146" data-mp="2ymaizxhvf72s">
                {item.label}
                <ChevronDownIcon className={`h-5 w-5 text-muted transition-transform duration-200 ${expanded === item.label ? "rotate-180" : ""}`} aria-hidden="true" data-id="element-147" data-mp="1jim91go6veud" />
              </button>
              <AnimatePresence initial={false} data-id="element-148" data-mp="2c7be1qsd84be">
                {expanded === item.label && <motion.ul initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: "auto",
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.22,
            ease
          }} className="overflow-hidden" data-id="element-149" data-mp="2799smz7gvswr">
                    {item.children.map(child => <li key={child.href} data-id="element-150" data-mp="2q6jc2gcsl6e0">
                        <Link to={child.href} className="block py-2 pl-4 text-base text-muted hover:text-ink" data-id="element-151" data-mp="2q5rifb2r9iqd">
                          {child.label}
                        </Link>
                      </li>)}
                    <li className="h-3" aria-hidden="true" data-id="element-152" data-mp="ekscn6q66xaz" />
                  </motion.ul>}
              </AnimatePresence>
            </li> : <li key={item.label} data-id="element-153" data-mp="jgzaec8ex2hu">
              <Link to={item.href} className="block py-4 font-display text-xl text-ink" data-id="element-154" data-mp="5jb01ybz1dr1">
                {item.label}
              </Link>
            </li>)}
      </ul>
      <Link to="/contact" className="mt-6 flex w-full items-center justify-center rounded-full bg-clay px-5 py-3.5 text-base font-semibold text-white" data-id="element-155" data-mp="3rr0u9c784wky">
        Demander un devis
      </Link>
    </motion.nav>;
}